module.exports = __webpack_public_path__ + "static/img/t-2-error-miss.118ff5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/StranNeObstaja/t-2-error-miss.png
// module id = EEwl
// module chunks = 3